import React, { useState, useEffect } from 'react';

const DateSelector = ({
   dateList, 
   dev_id, 
   sensor_id,
  card_sensor_data,
  //actualFieldsArray,
  actual_fields,
  t_update_request_graph_rx_data_mobile,
  collectDataForGraph,
/*  t_graph_update_graph_selectedDate_by_devId_and_sensorId, 
  form_graph_selected_date, 
  t_update_request_graph_by_devId_and_sensorId,
  t_update_request_graph_rx_data */
  }) => {
  

  const [selectedDate, setSelectedDate] = useState(dateList[0]);
  const [isCustomDate, setIsCustomDate] = useState(false);

  const actual_fields_qty = actual_fields ? actual_fields.length : 0;
  //console.log('actual_fields_qty: ', actual_fields_qty)
  useEffect(() => {
    /* t_graph_update_graph_selectedDate_by_devId_and_sensorId(dateList[0], dev_id, sensor_id) */
  }, [])

/*   const fieldsQty = () => {
    const fields = []
    card_sensor_data.forEach((card) => {
      if (!card.form_sensor_field_ignore) fields.push(card.db_field);
    });
    
    return fields.length;
  } */

  //console.log('fieldsQty: ', fieldsQty())

  const dates1 = [
    '2024-01-01',
    '2024-01-02',
    '2024-01-03',
    '2024-01-04',
    '2024-01-05',
    '2024-01-06',
    '2024-01-07',
    '2024-01-08',
    '2024-01-09',
    '2024-01-10',
  ];
  //const dates = [];
  //console.log(typeof(dateList))
  //artray or 0 test
  //const dates = typeof(dateList) === "object" ? dateList : []
  const dates = dateList;

  const handleSubmit = (event) => {
    event.preventDefault();
    //test valid date
    if (selectedDate === 'custom') return 

    //console.log('selected date:', selectedDate)
    //console.log('actual_fields_qty:', actual_fields_qty)
/*     console.log('actual_fields: ', actual_fields ? actual_fields.length : 0)
    console.log('actual_fields: ', actual_fields ? actual_fields.length : 0)
    console.log('dev_id: ', dev_id)
    console.log('sensor_id: ', sensor_id)
    console.log('graph_selected_date: ', selectedDate)
    console.log('field_list: ', actual_fields) */
    collectDataForGraph(selectedDate)
/*     t_update_request_graph_rx_data_mobile({
      dev_id: dev_id,
      sensor_id: sensor_id,
      graph_selected_date: selectedDate,
      field_list: actual_fields,
    }) */
    // test necessiary for fields qty check
    //if (fieldsQty() === 0) return; 

    // Handle form submission logic here
     //t_graph_update_graph_selectedDate_by_devId_and_sensorId(selectedDate, dev_id, sensor_id)
   /* t_update_request_graph_by_devId_and_sensorId(dev_id, sensor_id)
    t_update_request_graph_rx_data() */
    //console.log('Selected date submitted:', selectedDate);
  };
/* 
          dev_id: state.dev.request_graph_by_sensor.dev_id,
          sensor_id: state.dev.request_graph_by_sensor.sensor_id,
          date_i: state.dev.request_graph_by_sensor.graph_selected_date,
          fields: state.dev.request_graph_by_sensor.field_list,

*/
  const handleSelectChange = (e) => {
    const value = e.target.value;
    //console.log(value, selectedDate)
    setSelectedDate(value);
    setIsCustomDate(value === 'custom');
    //t_graph_update_graph_selectedDate_by_devId_and_sensorId(value, dev_id, sensor_id)
  };

   //console.log(card_sensor_data, form_graph_selected_date)
   //console.log('actual_fields_qty: ', actual_fields_qty)
  return (
    <div className="float-end">
        <form className="form-inline" onSubmit={handleSubmit}>

          <div className="form-group mx-sm-3 mb-2">
            <label htmlFor="dateSelect" className="sr-only">Select or Enter Date</label>
            <select
              id="dateSelect"
              className="form-control"
              value={isCustomDate ? 'custom' : selectedDate}
              onChange={handleSelectChange}
            >
              <option value="" disabled>Select a date</option>
              {dates.map((date) => (
                <option key={date} value={date}>
                  {date}
                </option>
              ))}
              <option value="custom">Custom Date</option>
            </select>
          </div>
          {isCustomDate && (
            <div className="form-group mx-sm-3 mb-2">
              <label htmlFor="customDateInput" className="sr-only">Custom Date</label>
              <input
                type="date"
                id="customDateInput"
                className="form-control"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </div>
          )}
          {/*actual_fields <button type="submit" className={`btn btn-secondary mb-2 ' + ${fieldsQty() === 0 ? 'disabled': ''} `} aria-pressed="false">Make Graph</button> */}
          
          <button type="submit" className={`btn btn-primary mb-2 ' + ${actual_fields_qty ? '' : 'disabled'} `}>Graph</button>
        </form>
    </div>
  );
};

export default DateSelector;